var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navbar'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view',{attrs:{"allmodules":_vm.allmodules,"allmajors":_vm.allmajors,"sepMappings":_vm.sepMappings}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }